import { getStaticAssetComponentEntries } from './get-static-asset-component-entries.js'
export function getStaticAssetComponents(assetDirectory: 'ui' | 'custom'): string[] {
  return getStaticAssetComponentEntries(assetDirectory).map((entry) => entry.name)
}
